/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _everyInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/every";import breaker from"./breaker";import checkType from"./checkType";import each from"./each";import isFunction from"./isFunction";const every=function(e,r,t){let n,c=!1;return r=r||function(e){return e},checkType(e)&&(c=!0,isFunction(_everyInstanceProperty(e)))?_everyInstanceProperty(e).call(e,r,t):(n=!0,each(e,((e,o)=>{if(c||(e=e.value),n=n&&!!r.call(t,e,o,undefined),!n)return breaker}),t),n)};export default every;